export default __webpack_public_path__ + "static/media/redux.a313f503.svg";